import { LayoutGrid, Zap, Lock, Sparkles, Settings } from 'lucide-react';

// Single source of truth for primary navigation. Consumed by both the desktop
// AppSidebar and the mobile MobileTabBar so they can never drift.
// Icons chosen for clarity (previously: Smartphone/Bot/Drama — replaced).
export const NAV_ITEMS = [
  { id: 'devices', label: 'Devices', icon: LayoutGrid, path: '/devices', feature: 'devices' },
  { id: 'automations', label: 'Automations', icon: Zap, path: '/automations', feature: 'automations' },
  { id: 'smartlocks', label: 'Locks', icon: Lock, path: '/smartlocks', feature: 'smartLocks' },
  { id: 'scenes', label: 'Scenes', icon: Sparkles, path: '/scenes', feature: 'scenes' },
  { id: 'settings', label: 'Settings', icon: Settings, path: '/settings', feature: 'systemSettings' },
];
